module.exports = "<section class=\"alerts-maintenance-history\">\r\n    <nvd3 options=\"vm.chartOptions\" data=\"vm.chartData\"></nvd3>\r\n</section>";